import type FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateQueryString',
    (recipientWell: FindControlViewState, queryString: string) => {
        recipientWell.queryString = queryString;
    }
);
